// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router';

const NavLink = ({ to: path, label }, context) => (
  <li className={cx({ active: context.router.isActive(path) })}>
    <Link to={path}>{label}</Link>
  </li>
);

NavLink.contextTypes = { router: PropTypes.object };

export const SettingsNav = ({ entity }) => (
  <div className="well">
    <ul className="nav nav-list">
      <li className="nav-header">{entity.type} Settings</li>
      <NavLink
        to={`/a/portal/entity_settings/${entity.id}/notification_preferences`}
        label="Notification Preferences"
      />
      <NavLink
        to={`/a/portal/entity_settings/${entity.id}/referral_checklist_template`}
        label="Referral Checklist Template"
      />
      {entity.type === 'Location' ? (
        <NavLink
          to={`/a/portal/entity_settings/${entity.id}/accepting_new_patients`}
          label="Accepting New Patients"
        />
      ) : null}
      {entity.type === 'Organization' ? (
        <NavLink
          to={`/a/portal/entity_settings/${entity.id}/referral_tags`}
          label="Referral Tags"
        />
      ) : null}
      {entity.type === 'Organization' && entity.brandedPortalEnabled && (
        <NavLink
          to={`/a/portal/entity_settings/${entity.id}/questionnaire_templates`}
          label="Questionnaire Templates"
        />
      )}
    </ul>
  </div>
);
